"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DslCustomInputType = void 0;
var DslCustomInputType;
(function (DslCustomInputType) {
    DslCustomInputType["CURRENCY_APPLIES"] = "currencyapplies";
    DslCustomInputType["CURRENCY_PERCENTAGE"] = "currencypercentage";
    DslCustomInputType["CURRENCY_WITH_NUMBER"] = "currencywithnumber";
    DslCustomInputType["CURRENCY_WITH_TYPE"] = "currencywithtype";
    DslCustomInputType["EMBEDDED_COVERAGE"] = "embedded-coverage";
    DslCustomInputType["ADDRESS_OR_STATE"] = "address-or-state";
    DslCustomInputType["NUMBER_OR_CHECKBOX"] = "number-or-checkbox";
    DslCustomInputType["CURRENCY_OR_CHECKBOX"] = "currency-or-checkbox";
})(DslCustomInputType = exports.DslCustomInputType || (exports.DslCustomInputType = {}));
//# sourceMappingURL=coverage-dsl-custom-inputs.js.map